import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import { KButton, KIcon, KTextInput } from "@kyburz/kdesign-system";
import ChipList from "../../../components/chips/ChipList";
import useSetState from "../../../hooks/useSetState";
import {
  getVehicleTemplateParameters,
  createVehicleTemplateParameter,
  deleteParameter,
} from "../../../apiCalls/admin/vehicleTemplates";
import { setAlert } from "../../../redux/actions/actions";

const useStyle = makeStyles(() => ({
  root: {
    marginTop: "16px",
    minHeight: "100px",
    padding: "16px 24px 16px 24px",
    backgroundColor: "white",
    borderRadius: 4,
  },
  input: {
    display: "flex",
  },
}));

const VehicleParametersWidget = () => {
  const classes = useStyle();
  const dispatch = useDispatch();

  const [{ chipData, parameterValue, refresh }, setState] = useSetState({
    chipData: [],
    parameterValue: "",
    refresh: false,
  });

  const addParameter = async (e) => {
    e.preventDefault();
    if (parameterValue !== "") {
      const res = await createVehicleTemplateParameter(parameterValue);
      if (res.data) {
        dispatch(setAlert("Successfully added the parameter", "success"));
        setState({ parameterValue: "", refresh: true });
      }
    }
  };

  const handleChange = (e) => setState({ [e.target.name]: e.target.value });

  const handleDelete = (chipToDelete) => () => {
    setState({
      chipData: chipData.filter((chip) => chip.key !== chipToDelete.key),
    });
    deleteParameter(chipToDelete.key);
  };

  useEffect(() => {
    getVehicleTemplateParameters().then((res) =>
      setState({
        chipData: res.data.map((x) => ({ key: x._id, label: x.parameter })),
        refresh: false,
      }),
    );
  }, [refresh]);

  return (
    <div className={classes.root}>
      <Typography variant="subtitle2">Vehicle Template Parameters</Typography>
      <div className={classes.input}>
        <KTextInput
          value={parameterValue}
          onChange={handleChange}
          name="parameterValue"
          placeholder="Enter a new parameter name"
          style={{ marginRight: "16px" }}
          helperText="Press enter to add a parameter"
        />
        <KButton
          children="Add"
          onClick={addParameter}
          icon={<KIcon icon="plus" />}
        />
      </div>
      <ChipList chipData={chipData} handleDelete={handleDelete} />
    </div>
  );
};

export default VehicleParametersWidget;
